import { useModal } from './useModal'

type UseListenHoverParams = {
  onHover?: (e: React.MouseEvent) => void
  onUnhover?: () => void
}

export const useListenHover = ({
  onHover,
  onUnhover,
}: UseListenHoverParams = {}) => {
  const { isOpen, open, close } = useModal(false)

  const onMouseEnter = (e: React.MouseEvent) => {
    open()
    onHover?.(e)
  }

  const onMouseLeave = () => {
    close()
    onUnhover?.()
  }

  return { isOpen, onMouseEnter, onMouseLeave }
}
